import React from "react";
import NuovaPraticaForm from "../components/NuovaPraticaForm";

const SigningNew = () => {
  return <NuovaPraticaForm />;
};
export default SigningNew;
